@if (_date) {
  {{ _date | datetime:format }}
}
